import mixpanel from 'mixpanel-browser';

const MIXPANEL_TOKEN = '781f84f6fb3c714a07988982025411c2';

// Initialize once
if (MIXPANEL_TOKEN) {
  mixpanel.init(MIXPANEL_TOKEN, {
    debug: false,
    track_pageview: true, // Auto-track page views
  });
}

export const analytics = {
  track: (event, properties = {}) => {
    if (!MIXPANEL_TOKEN) return;
    mixpanel.track(event, properties);
  },

  identify: (email, traits = {}) => {
    if (!MIXPANEL_TOKEN) return;
    mixpanel.identify(email);
    mixpanel.people.set(traits);
  },
};
